"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DictionaryToolbar = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const ButtonGroup_1 = __importDefault(require("@material-ui/core/ButtonGroup/ButtonGroup"));
const detail_types_1 = require("../../detail/detail-types");
const dictionary_api_1 = require("./dictionary-api");
const detail_context_1 = require("../../detail/detail-context");
const detail_styles_1 = require("../../detail/detail-styles");
const detail_action_button_1 = require("../../action-button/detail/detail-action-button");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
function DictionaryToolbar() {
    var _a;
    const intl = react_intl_1.useIntl();
    const classes = detail_styles_1.useStyles();
    const { source, mode } = react_1.useContext(detail_context_1.DetailContext);
    const activateCall = event_callback_hook_1.useEventCallback((id) => {
        return dictionary_api_1.activateItem(source.url, id);
    });
    const deactivateCall = event_callback_hook_1.useEventCallback((id) => {
        return dictionary_api_1.deactivateItem(source.url, id);
    });
    return (react_1.default.createElement(react_1.default.Fragment, null, mode === detail_types_1.DetailMode.VIEW && (react_1.default.createElement(ButtonGroup_1.default, { size: "small", variant: "outlined", className: classes.toolbarIndentLeft }, ((_a = source.data) === null || _a === void 0 ? void 0 : _a.active) ? (react_1.default.createElement(detail_action_button_1.DetailActionButton, { promptKey: "DICTIONARY_DEACTIVATE", buttonLabel: intl.formatMessage({
            id: 'EAS_DICTIONARY_EVIDENCE_TOOLBAR_BTN_DEACTIVATE',
            defaultMessage: 'Deaktivovat',
        }), buttonTooltip: intl.formatMessage({
            id: 'EAS_DICTIONARY_EVIDENCE_TOOLBAR_TOOLTIP_DEACTIVATE',
            defaultMessage: 'Otevře dialog s potvrzením akce',
        }), dialogTitle: intl.formatMessage({
            id: 'EAS_DICTIONARY_EVIDENCE_TOOLBAR_DIALOG_TITLE_DEACTIVATE',
            defaultMessage: 'Varování',
        }), dialogText: intl.formatMessage({
            id: 'EAS_DICTIONARY_EVIDENCE_TOOLBAR_DIALOG_TEXT_DEACTIVATE',
            defaultMessage: 'Záznam číselníku se vyřadí ze seznamu použitelných hodnot v evidencích',
        }), successMessage: intl.formatMessage({
            id: 'EAS_EVIDENCE_MSG_DEACTIVATED_SUCCESS',
            defaultMessage: 'Záznam byl úspěšně deaktivován.',
        }), errorMessage: intl.formatMessage({
            id: 'EAS_EVIDENCE_MSG_DEACTIVATED_ERROR',
            defaultMessage: 'Chyba volání funkce: {detail}',
        }), apiCall: deactivateCall })) : (react_1.default.createElement(detail_action_button_1.DetailActionButton, { promptKey: "DICTIONARY_ACTIVATE", buttonLabel: intl.formatMessage({
            id: 'EAS_DICTIONARY_EVIDENCE_TOOLBAR_BTN_ACTIVATE',
            defaultMessage: 'Aktivovat',
        }), buttonTooltip: intl.formatMessage({
            id: 'EAS_DICTIONARY_EVIDENCE_TOOLBAR_TOOLTIP_ACTIVATE',
            defaultMessage: 'Otevře dialog s potvrzením akce',
        }), dialogTitle: intl.formatMessage({
            id: 'EAS_DICTIONARY_EVIDENCE_TOOLBAR_DIALOG_TITLE_ACTIVATE',
            defaultMessage: 'Varování',
        }), dialogText: intl.formatMessage({
            id: 'EAS_DICTIONARY_EVIDENCE_TOOLBAR_DIALOG_TEXT_ACTIVATE',
            defaultMessage: 'Záznam číselníku se přidá do seznamu použitelných hodnot v evidencích',
        }), successMessage: intl.formatMessage({
            id: 'EAS_EVIDENCE_MSG_ACTIVATED_SUCCESS',
            defaultMessage: 'Záznam byl úspěšně aktivován.',
        }), errorMessage: intl.formatMessage({
            id: 'EAS_EVIDENCE_MSG_ACTIVATED_ERROR',
            defaultMessage: 'Chyba volání funkce: {detail}',
        }), apiCall: activateCall }))))));
}
exports.DictionaryToolbar = DictionaryToolbar;
//# sourceMappingURL=dictionary-toolbar.js.map